export var TextVariantType;
(function (TextVariantType) {
    TextVariantType["FONT_HEADING_1"] = "FONT_HEADING_1";
    TextVariantType["FONT_HEADING_2"] = "FONT_HEADING_2";
    TextVariantType["FONT_HEADING_3"] = "FONT_HEADING_3";
    TextVariantType["FONT_HEADING_4"] = "FONT_HEADING_4";
    TextVariantType["FONT_HEADING_5"] = "FONT_HEADING_5";
    TextVariantType["FONT_HEADING_6"] = "FONT_HEADING_6";
    TextVariantType["FONT_HEADING_7"] = "FONT_HEADING_7";
    TextVariantType["FONT_HEADING_8"] = "FONT_HEADING_8";
    TextVariantType["FONT_HEADING_9"] = "FONT_HEADING_9";
    TextVariantType["FONT_HEADING_10"] = "FONT_HEADING_10";
    TextVariantType["FONT_HEADING_11"] = "FONT_HEADING_11";
    TextVariantType["FONT_HEADING_12"] = "FONT_HEADING_12";
    TextVariantType["FONT_HEADING_13"] = "FONT_HEADING_13";
    TextVariantType["FONT_HEADING_14"] = "FONT_HEADING_14";
    TextVariantType["FONT_HEADING_15"] = "FONT_HEADING_15";
    TextVariantType["FONT_HEADING_16"] = "FONT_HEADING_16";
    TextVariantType["FONT_HEADING_17"] = "FONT_HEADING_17";
    TextVariantType["FONT_HEADING_18"] = "FONT_HEADING_18";
    TextVariantType["FONT_HEADING_19"] = "FONT_HEADING_19";
    TextVariantType["FONT_HEADING_20"] = "FONT_HEADING_20";
    TextVariantType["FONT_HEADING_21"] = "FONT_HEADING_21";
    TextVariantType["FONT_HEADING_22"] = "FONT_HEADING_22";
    TextVariantType["FONT_HEADING_23"] = "FONT_HEADING_23";
    TextVariantType["FONT_HEADING_24"] = "FONT_HEADING_24";
    TextVariantType["FONT_HEADING_25"] = "FONT_HEADING_25";
    TextVariantType["FONT_HEADING_26"] = "FONT_HEADING_26";
    TextVariantType["FONT_HEADING_27"] = "FONT_HEADING_27";
    TextVariantType["FONT_HEADING_28"] = "FONT_HEADING_28";
    TextVariantType["FONT_HEADING_29"] = "FONT_HEADING_29";
    TextVariantType["FONT_HEADING_30"] = "FONT_HEADING_30";
    TextVariantType["FONT_HEADING_31"] = "FONT_HEADING_31";
    TextVariantType["FONT_HEADING_32"] = "FONT_HEADING_32";
    TextVariantType["FONT_HEADING_33"] = "FONT_HEADING_33";
    TextVariantType["FONT_HEADING_49"] = "FONT_HEADING_49";
    TextVariantType["FONT_HEADING_50"] = "FONT_HEADING_50";
    TextVariantType["FONT_HEADING_100"] = "FONT_HEADING_100";
    TextVariantType["FONT_HEADING_200"] = "FONT_HEADING_200";
    TextVariantType["FONT_HEADING_210"] = "FONT_HEADING_210";
    TextVariantType["FONT_HEADING_225"] = "FONT_HEADING_225";
    TextVariantType["FONT_HEADING_230"] = "FONT_HEADING_230";
    TextVariantType["FONT_HEADING_250"] = "FONT_HEADING_250";
    TextVariantType["FONT_HEADING_260"] = "FONT_HEADING_260";
    TextVariantType["FONT_HEADING_300"] = "FONT_HEADING_300";
    TextVariantType["FONT_HEADING_310"] = "FONT_HEADING_310";
    TextVariantType["FONT_HEADING_400"] = "FONT_HEADING_400";
    TextVariantType["FONT_HEADING_410"] = "FONT_HEADING_410";
    TextVariantType["FONT_HEADING_450"] = "FONT_HEADING_450";
    TextVariantType["FONT_HEADING_460"] = "FONT_HEADING_460";
    TextVariantType["FONT_PARAGRAPH_50"] = "FONT_PARAGRAPH_50";
    TextVariantType["FONT_PARAGRAPH_60"] = "FONT_PARAGRAPH_60";
    TextVariantType["FONT_PARAGRAPH_100"] = "FONT_PARAGRAPH_100";
    TextVariantType["FONT_PARAGRAPH_110"] = "FONT_PARAGRAPH_110";
    TextVariantType["LINK_FONT_PARAGRAPH_50"] = "LINK_FONT_PARAGRAPH_50";
    TextVariantType["LINK_FONT_PARAGRAPH_60"] = "LINK_FONT_PARAGRAPH_60";
    TextVariantType["LINK_FONT_PARAGRAPH_100"] = "LINK_FONT_PARAGRAPH_100";
    TextVariantType["LINK_FONT_PARAGRAPH_110"] = "LINK_FONT_PARAGRAPH_110";
    TextVariantType["FONT_PARAGRAPH_200"] = "FONT_PARAGRAPH_200";
    TextVariantType["FONT_PARAGRAPH_210"] = "FONT_PARAGRAPH_210";
    TextVariantType["FONT_PARAGRAPH_250"] = "FONT_PARAGRAPH_250";
    TextVariantType["FONT_PARAGRAPH_260"] = "FONT_PARAGRAPH_260";
    TextVariantType["LINK_FONT_PARAGRAPH_200"] = "LINK_FONT_PARAGRAPH_200";
    TextVariantType["LINK_FONT_PARAGRAPH_210"] = "LINK_FONT_PARAGRAPH_210";
    TextVariantType["LINK_FONT_PARAGRAPH_250"] = "LINK_FONT_PARAGRAPH_250";
    TextVariantType["LINK_FONT_PARAGRAPH_260"] = "LINK_FONT_PARAGRAPH_260";
    TextVariantType["FONT_PARAGRAPH_350"] = "FONT_PARAGRAPH_350";
    TextVariantType["FONT_PARAGRAPH_360"] = "FONT_PARAGRAPH_360";
    TextVariantType["FONT_PARAGRAPH_400"] = "FONT_PARAGRAPH_400";
    TextVariantType["FONT_PARAGRAPH_410"] = "FONT_PARAGRAPH_410";
    TextVariantType["LINK_FONT_PARAGRAPH_350"] = "LINK_FONT_PARAGRAPH_350";
    TextVariantType["LINK_FONT_PARAGRAPH_360"] = "LINK_FONT_PARAGRAPH_360";
    TextVariantType["LINK_FONT_PARAGRAPH_400"] = "LINK_FONT_PARAGRAPH_400";
    TextVariantType["LINK_FONT_PARAGRAPH_410"] = "LINK_FONT_PARAGRAPH_410";
    TextVariantType["FONT_PARAGRAPH_500"] = "FONT_PARAGRAPH_500";
    TextVariantType["FONT_PARAGRAPH_550"] = "FONT_PARAGRAPH_550";
    TextVariantType["LINK_FONT_PARAGRAPH_500"] = "LINK_FONT_PARAGRAPH_500";
    TextVariantType["LINK_FONT_PARAGRAPH_550"] = "LINK_FONT_PARAGRAPH_550";
    TextVariantType["FONT_PARAGRAPH_650"] = "FONT_PARAGRAPH_650";
    TextVariantType["FONT_PARAGRAPH_700"] = "FONT_PARAGRAPH_700";
    // DS Only
    TextVariantType["FONT_TITLE_50"] = "FONT_TITLE_50";
    TextVariantType["FONT_TITLE_100"] = "FONT_TITLE_100";
    TextVariantType["FONT_AVATARL"] = "FONT_AVATARL";
    TextVariantType["FONT_AVATARMS"] = "FONT_AVATARMS";
    TextVariantType["FONT_AVATARXS"] = "FONT_AVATARXS";
    TextVariantType["FONT_AVATARXXS"] = "FONT_AVATARXXS";
    TextVariantType["FONT_INPUTCURRENCY"] = "FONT_INPUTCURRENCY";
    TextVariantType["FONT_DIGIT_PASSWORD_CIRCLE"] = "FONT_DIGIT_PASSWORD_CIRCLE";
    TextVariantType["FONT_DIGIT_PASSWORD_SQUARE"] = "FONT_DIGIT_PASSWORD_SQUARE";
})(TextVariantType || (TextVariantType = {}));
//# sourceMappingURL=variants.js.map